import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { UserService } from 'src/app/services/user-services/user.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-hc-component-confirm',
    templateUrl: './hc-component-confirm.component.html',
    styleUrls: ['./hc-component-confirm.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class HcComponentConfirmComponent implements OnInit {

  currentUser: any = null;
  confirmInfoTranslation: any;
  currentLanguage: string;

  
  constructor(
    private router: Router,
    private userService: UserService,
    private translateService: TranslateService,


  ) { 
  }


  ngOnInit(): void {
    this.currentLanguage = this.translateService.currentLang;
    this.currentUser = this.userService.getInfos();
  } 
  backtoInfo() {
    this.router.navigate([this.currentLanguage+'/housing-certificate/informations']);
  }

  gotoPayment(){
    this.router.navigate([this.currentLanguage+'/housing-certificate/payment']);
  }
 

}
